import { Body, Divider } from '@hover/blueprint';
import { Flex } from '@hover/blueprint/chakra';
import React from 'react';

import { ProductListItem } from 'src/modules/designStudio/components/DesignMenu/Menu/TemplateMenu/products/ProductListItem';
import { ProductTabletListItem } from 'src/modules/designStudio/components/DesignMenu/Menu/TemplateMenu/products/ProductTabletListItem';
import type { TemplateProductCategories } from 'src/modules/designStudio/components/DesignMenu/Menu/TemplateMenu/products/types';
import type { MaterialGroup } from 'src/modules/designStudio/helpers/productSelection/types';
import { useIsTabletSize } from 'src/modules/renderings/hooks';

export const TemplateProductCategory = ({
  category,
  materials,
  onMaterialSelected,
}: {
  category: TemplateProductCategories;
  materials: MaterialGroup[];
  onMaterialSelected: (material: MaterialGroup) => void;
}) => {
  const isTablet = useIsTabletSize();

  const defaultProductList = materials.map(material => (
    <ProductListItem
      key={material.variation!.uuid}
      material={material}
      onClick={() => onMaterialSelected(material)}
    />
  ));

  const tabletProductList = (
    <Flex
      direction="row"
      gap={400}
      justifyContent="flex-start"
      width="100%"
      wrap="wrap"
    >
      {materials.map(material => (
        <ProductTabletListItem
          key={material.variation!.uuid}
          material={material}
          onClick={() => onMaterialSelected(material)}
        />
      ))}
    </Flex>
  );

  return (
    <Flex direction="column" gap={400}>
      <Body fontWeight={700}>{category}</Body>
      {isTablet ? tabletProductList : defaultProductList}
      <Divider />
    </Flex>
  );
};
